import React, { useEffect } from 'react';
import { getDataSession, validarExisteSucursalPrincipal } from 'views/Utils/Common';
import ListTable from 'components/table/ListTable'
import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import RenderButtons from 'components/table/RenderButtons';
import { useUIUtils } from 'hooks/useUIUtils';

const List = ({ match, saludo, subtitulo }) => {
    const { changeGlobalTitle } = useUIUtils()
    const { t } = useTranslation("common");
    const { path } = match
    const columns = [
        { renderCell: RenderButtons, headerName: '', maxWidth: 20, path: path, opciones: "ver" },
        { field: 'id', headerName: 'Id', width: 70 },
        { field: 'folio', headerName: 'Folio', flex: 1 },
        { field: 'fechahora_Creacion', headerName: 'Fecha', flex: 1 },
        { field: 'almacen', headerName: 'Almacen', flex: 1 },
        { field: 'concepto_Inventario', headerName: 'Concepto_Inventario', flex: 1 },
        { field: 'naturaleza_Concepto', headerName: 'Movimiento', flex: 1 },
        { field: 'usuario_Creacion', headerName: 'Usuario', flex: 1 },
        { field: 'cancelado', headerName: 'Cancelado', flex: 1 },
        { field: 'aplicado', headerName: 'Aplicado', flex: 1 },

    ];

    useEffect(() => { 
        changeGlobalTitle('Entradas de Inventarios', 'Todas las entradas de inventarios por sucursal')
        validarExisteSucursalPrincipal();
     }, [changeGlobalTitle]);

    return (
        <>
            <div className='container-fluid'>
                <div className='col-12 col-sm-12 col-md-12 row'>
                    <div className='col-sm-5' >
                        <Link to={`${path}/add`} className='btn btn-outline-primary m-1'>
                            <svg
                                xmlns='http://www.w3.org/2000/svg'
                                width='20'
                                height='20'
                                fill='currentColor'
                                className='bi bi-plus-square'
                                viewBox='0 0 16 16'
                            >
                                <path d='M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z' />
                                <path d='M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z' />
                            </svg>
                            &nbsp; {t('app.SwalFire.nuevo')}
                        </Link>
                        &nbsp;
                    </div>
                </div>
                <div className='col-md-12'>
                    <ListTable
                        columns={columns}
                        path={path}
                        url={`existencias/MovimientoInventario/GetList?sucursal_Id=${getDataSession('sucursal')}&tipo=E`}
                    />
                </div>
            </div>
        </>
    );
};

export { List };
